import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import {Select} from "antd";

export default function AeTitleSelectBox({...props}) {
    const [aeTitles, setAeTitles] = useState([])
    const [loading, setLoading] = useState(false)

    const getAeTitles = async () => {
        setLoading(true)
        const response = await ApiService.AutoExport.GetAvailableAeTitles();
        if(response.success) {
            setAeTitles(response.data.map(aeTitle => ({
                label: aeTitle,
                value: aeTitle
            })))
        }
        setLoading(false)
    }

    useEffect(() => {
        getAeTitles()
    }, [])

    return (
        <Select
            loading={loading}
            allowClear
            options={aeTitles}
            showSearch
            filterOption={(input, option) => {
                return (option?.label ?? '').toUpperCase().includes(input.toUpperCase())
            }}
            {...props}
        />
    )
}
